
export const NETWORK_KEY_NAME = {
  1: "mainnet",
  4: "rinkeby",
};
